
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education-and-advocacy-department",
      function () {
        return require("private-next-pages/education-and-advocacy-department.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education-and-advocacy-department"])
      });
    }
  